import styled, { css } from 'styled-components';
import { color, space, font, query } from '@design/templateFns';
import Block from '@components/Layout/Block';

export const StyledBlock = styled(Block)<{ $divider: boolean }>`
  ${({ $divider }) =>
    $divider &&
    css`
      padding-bottom: 0;
      position: relative;

      > div {
        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          background-color: ${color('gray2')};
          margin-top: ${space('x6')};

          @media screen and (${query.atLeast('desktop')}) {
            margin-top: ${space('x10')};
          }
        }
      }
    `}
`;
